import moment from "moment";

export const orderStatuses = [
  { value: "pending", label: "Pending" },
  { value: "paymentConfirmed", label: "Payment Confirmed" },
  { value: "processing", label: "Processing" },
  { value: "outForDelivery", label: "Out for Delivery" },
  { value: "delivered", label: "Delivered" },
  { value: "completed", label: "Completed" },
  { value: "cancelled", label: "Cancelled" },
];

const paymentMethods = {
  cod: "Cash on Delivery",
  bankTransfer: "Bank Transfer",
  paypal: "PayPal",
};

const statusColors = {
  pending: "warning",
  paymentConfirmed: "info",
  processing: "info",
  outForDelivery: "primary",
  delivered: "success",
  completed: "success",
  cancelled: "danger",
};

export const statusLabel = (status) =>
  orderStatuses.find((s) => s.value === status)?.label ?? status ?? "N/A";

export const statusColor = (status) => statusColors[status] ?? "secondary";

export const paymentMethodLabel = (method) =>
  paymentMethods[method] ?? method ?? "N/A";

export const userName = (user) =>
  user?.displayName || user?.fullName || user?.businessName || "N/A";

export const formatDateTime = (date) =>
  date ? moment(date).format("DD/MM/YYYY HH:mm") : "N/A";

export const formatTotal = (value, currency) => {
  if (!Number.isFinite(value)) return "N/A";
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency || "USD",
      minimumFractionDigits: 0,
    }).format(value);
  } catch (_) {
    // Unknown currency code: show the raw amount with the code.
    return `${value} ${currency ?? ""}`.trim();
  }
};
